import { c as _c } from "react/compiler-runtime";
import MaskedInputComponent, { MaskConfig, Props as MaskedInputProps } from '@spa/components/form-group/masked-input.component';
import React, { ReactElement, memo } from 'react';
import { InputMode } from '@spa/components/form-group/InputMode';
export type Props = Omit<MaskedInputProps, 'config'>;
export const GIFT_CARD_ONLINE_ID_MASK = '____-____-____-____';
const giftCardIdMaskConfig: MaskConfig = {
  mask: GIFT_CARD_ONLINE_ID_MASK,
  isAllowedChar: (char: string): boolean => /^[A-Za-z0-9]$/.test(char),
  allowedCharClass: 'A-Za-z0-9',
  inputMode: InputMode.TEXT
};
function InputGiftCardIdComponent(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <MaskedInputComponent {...props} config={giftCardIdMaskConfig} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export default memo(InputGiftCardIdComponent);